import React from "react";
import Label from "../../../components/label/Label";
import { CircularProgress, Grid, IconButton } from "@mui/material";
import { Box } from "@mui/system";
import Carousel from "react-multi-carousel";
import PdfICon from "../../../components/icons/PdfIcon";
import MapToolBar from "../../../components/mapData/MapToolBar";
import PrismaZoom from "react-prismazoom";
import ImageMapper from "react-img-mapper";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as acts from "../../../redux/processor/actions";
import AngleArrowLeft from "../../../assets/angle-circle-left-icon.svg";
import AngleArrowRight from "../../../assets/angle-circle-right-icon.svg";
import "./mapData.scss";

const styles = {
  margin: 0,
  fontSize: "10px",
  color: "#202020",
  fontfamily: "Montserrat",
};

const CustomLeftArrow = ({ onClick }) => (
  <button
    onClick={() => onClick()}
    className="slick-prev"
    variant="contained"
    size="medium"
    color="primary"
  >
    Prev
  </button>
);
const CustomRightArrow = ({ onClick }) => {
  return (
    <button
      className="slick-next"
      onClick={() => onClick()}
      variant="contained"
      size="medium"
      color="primary"
    >
      Next
    </button>
  );
};

class ImageViewer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // coorData: [],
      selectedFile: {
        tagName: null,
        fileNo: null, // index is considered as file
        pageNo: null,
      },

      zoom: 1,
      prismaZoom: React.createRef(),
      allowZoom: true,
      responsive: {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5,
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3,
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2,
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
        },
      },
      pageRotateAngle: 0,
      imageLoaded: false,
      selectedArea: {},
      data: [],
      entireCoorDataFromPageState: [],
      originalMapperWidth: 600,
      originalMapperHeight: 768,
      imageMapperWidth: 600,
      imageMapperHeight: 768,
      // page: 0,
    };
    // Create the child instance using react createRef
    this.child = React.createRef();
    this.checkIsImageLoadable = this.checkIsImageLoadable.bind(this);
  }

  componentDidMount() {
    this.props.acts.clearApiStatus();
    this.props.acts.setSelectedFileDataForProUpdateMapping({});
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // used this to set first pdf selected in initial state  and temp setting some initialn data
    if (nextProps?.coorData.length > 0) {
      const initialFileIndex = 0;

      if (
        Object.values(this?.state?.selectedFile).every(
          (x) => x === null || x === ""
        )
      ) {
        this.setState({
          selectedFile: {
            tagName: nextProps?.coorData[0]?.pdfName,
            fileNo: 0,
            pageNo: 0,
          },
        });
        this.setState({
          data: { ...nextProps?.coorData[0]?.pages[0] },
          entireCoorDataFromPageState: [...nextProps?.coorData],
        }); // initial page setting
        this.checkIsImageLoadable(initialFileIndex, 0); // the second argument is current page number
      }

      if (nextProps?.coorData?.length) {
        let sortedCoorData = nextProps?.coorData;

        sortedCoorData.map((fileData, index) => {
          const sortedPagesData = fileData.pages.sort((a, b) => {
            return parseInt(a.pageNo) - parseInt(b.pageNo);
          });
          sortedCoorData[index]["pages"] = sortedPagesData;
        });

        this.setState({ data: { ...sortedCoorData[0]?.pages[0] } }); // initial page setting
        this.props.acts.setSelectedFileDataForProUpdateMapping({
          tagName: nextProps?.coorData[0]?.pdfName,
          fileNo: 0,
          pageNo: 0,
        });
      }
    }

    if (
      nextProps?.pdfAndPageDetails &&
      Object.keys(nextProps?.pdfAndPageDetails).length !== 0
    ) {
      this.checkIsImageLoadable(
        nextProps?.pdfAndPageDetails?.fileNo,
        nextProps?.pdfAndPageDetails?.pageNo
      ); // the second argument is current page number

      let dataToSet = {
        ...this?.state?.entireCoorDataFromPageState[
          nextProps?.pdfAndPageDetails?.fileNo
        ]?.pages[nextProps?.pdfAndPageDetails?.pageNo],
      };

      this.setState({
        selectedFile: {
          // ...this.state.selectedFile,
          tagName: nextProps?.pdfAndPageDetails?.tagName,
          fileNo: nextProps?.pdfAndPageDetails?.fileNo,
          pageNo: nextProps?.pdfAndPageDetails?.pageNo,
        },
        pageRotateAngle: 0,
      });

      if (Object.keys(dataToSet).length !== 0) {
        let newAreas = [];
        nextProps?.pdfAndPageDetails?.coordinates?.map(
          (coords, indexOfCoodinates) => {
            const newAreaObj = {
              shape: "rect",
              coords: coords,
              preFillColor: "#ff00002e",
              fillColor: "#ff00002e",
            };
            newAreas.push(newAreaObj);
          }
        );

        this.setState({
          data: { ...dataToSet, areas: [...dataToSet?.areas, ...newAreas] },
        });
      }
      setTimeout(() => {
        document.getElementById("viewPdfId").scrollTo({
          top:
            nextProps?.pdfAndPageDetails &&
            nextProps?.pdfAndPageDetails?.coordinates[0] &&
            nextProps?.pdfAndPageDetails?.coordinates[0][1] &&
            nextProps?.pdfAndPageDetails?.coordinates[0][1] - 100 >= 0
              ? nextProps?.pdfAndPageDetails?.coordinates[0][1] - 100
              : 0, // substractiong 10 px in current ymin so it get display 10 px below from starting position
          behavior: "smooth",
        });
      }, 100);
    }
  }

  clicked = (area, index, e) => {
    this.setState({
      selectedArea: area,
    });

    const dataToUpdate = this.state.data;
    dataToUpdate.areas[index] = {
      ...this.state.data.areas[index],
      preFillColor: "#ff00002e",
      fillColor: "#ff00002e",
    };
    this.setState({
      data: { ...dataToUpdate },
    });
    this.props.acts.setOCRValue(area?.name, area?.coords);
  };

  checkIsImageLoadable = (fileIndex, pageNo) => {
    this.setState({ imageLoaded: false });
    if (this.props?.coorData[fileIndex]?.pages[pageNo].imageUrl) {
      const objImg = new Image();
      objImg.src = this.props?.coorData[fileIndex]?.pages[pageNo].imageUrl;
      objImg.onload = () => {
        this.setState({ imageLoaded: true });
      };
      objImg.onerror = () => {
        this.setState({ imageLoaded: true });
      };
    } else {
      this.setState({ imageLoaded: true });
    }
  };

  fitToScreenClick = () => {
    this.state.prismaZoom.current.reset();
    this.setState({
      pageRotateAngle: 0,
      imageMapperWidth: this?.state?.originalMapperWidth,
      imageMapperHeight: this?.state?.originalMapperHeight,
    });
  };

  rotateClick = (value) => {
    if (value === "right") {
      this.setState({ pageRotateAngle: this.state.pageRotateAngle + 90 });
    }
    if (value === "left") {
      this.setState({ pageRotateAngle: this.state.pageRotateAngle - 90 });
    }
  };

  onZoomChange = (zoom) => {
    this.setState({
      zoom: zoom,
    });
  };

  onClickZoom = (value) => {
    if (value === "out") {
      this.state.prismaZoom.current.zoomOut(1);
    } else {
      this.state.prismaZoom.current.zoomIn(1);
    }
  };

  searchPageClick = (value) => {
    if (
      value <
        this.props?.coorData[this.state.selectedFile?.fileNo].pages.length &&
      value >= 0
    ) {
      this.setState({
        selectedFile: {
          ...this.state.selectedFile,
          pageNo: Number(value),
        },
        pageRotateAngle: 0,
        data: this.props?.coorData[this.state?.selectedFile?.fileNo]?.pages[
          Number(value)
        ],
        imageMapperWidth: this?.state?.originalMapperWidth,
        imageMapperHeight: this?.state?.originalMapperHeight,
      });

      this.state.prismaZoom.current.reset();
      this.checkIsImageLoadable(this.state.selectedFile.fileNo, Number(value));
      this.props.acts.setSelectedFileDataForProUpdateMapping({
        ...this.state.selectedFile,
        pageNo: Number(value),
      });
    }
  };

  handlePageChange = (value) => {
    if (value === "prev" && this.state.selectedFile?.pageNo !== 0) {
      const prevPageNo = this.state.selectedFile?.pageNo - 1;
      this.setState({
        selectedFile: {
          ...this.state.selectedFile,
          pageNo: prevPageNo,
        },
        pageRotateAngle: 0,
        data: this.props?.coorData[this.state?.selectedFile?.fileNo]?.pages[
          prevPageNo
        ],
      });

      this.state.prismaZoom.current.reset();
      this.checkIsImageLoadable(this.state.selectedFile.fileNo, prevPageNo);
      this.props.acts.setSelectedFileDataForProUpdateMapping({
        ...this.state.selectedFile,
        pageNo: prevPageNo,
      });
    } else if (value === "next") {
      const nextPageNo = this.state.selectedFile?.pageNo + 1;

      this.setState({
        selectedFile: {
          ...this.state.selectedFile,
          pageNo: nextPageNo,
        },
        pageRotateAngle: 0,
        data: this.props?.coorData[this.state?.selectedFile?.fileNo]?.pages[
          nextPageNo
        ],
      });

      this.state.prismaZoom.current.reset();
      this.checkIsImageLoadable(this.state.selectedFile.fileNo, nextPageNo);
      this.props.acts.setSelectedFileDataForProUpdateMapping({
        ...this.state.selectedFile,
        pageNo: nextPageNo,
      });
    }
    this.setState({
      imageMapperWidth: this?.state?.originalMapperWidth,
      imageMapperHeight: this?.state?.originalMapperHeight,
    });
  };

  handleFileChange(tagName, index) {
    this.setState({
      selectedFile: {
        tagName: tagName,
        fileNo: index,
        pageNo: 0,
      },
      pageRotateAngle: 0,
      data: this?.props?.coorData[index]?.pages[0],
      imageMapperWidth: this?.state?.originalMapperWidth,
      imageMapperHeight: this?.state?.originalMapperHeight,
    });
    this.state.prismaZoom.current.reset();
    this.checkIsImageLoadable(index, 0);
    this.props.acts.setSelectedFileDataForProUpdateMapping({
      tagName: tagName,
      fileNo: index,
      pageNo: 0,
    });
  }

  onClickCellToRedirect = (tagName, pageNo, fileNo) => {
    if (tagName && !isNaN(pageNo) && !isNaN(fileNo)) {
      this.setState({
        selectedFile: {
          tagName: tagName,
          fileNo: fileNo,
          pageNo: pageNo,
        },
        pageRotateAngle: 0,
        data: this?.props?.coorData[fileNo]?.pages[pageNo],
      });
    }

    this.state.prismaZoom.current.reset();
    this.checkIsImageLoadable(fileNo, 0);
  };

  onClickChangeOrientation = () => {
    this.setState({
      imageMapperWidth: this?.state?.imageMapperHeight,
      imageMapperHeight: this?.state?.imageMapperWidth,
    });
  };

  render() {
    return (
      <Box className={this?.props?.isFullView ? "container-2" : "container-1"}>
        <Grid
         className="imageview-header"
        >
          <Grid item xs={10}>
            <div className="ac-processor-pdf-slider-body">
              <section>
                <div>
                  <Carousel
                    ssr
                    partialVisible
                    deviceType={this.props.deviceType}
                    itemClass="image-item"
                    responsive={this.state.responsive}
                    customRightArrow={<CustomRightArrow />}
                    customLeftArrow={<CustomLeftArrow />}
                  >
                    {this.props?.coorData?.map((file, index) => {
                      return (
                        <div
                          className="ac-processor-slider-content"
                          onClick={() =>
                            this.handleFileChange(file.pdfName, index)
                          }
                        >
                          <PdfICon
                            fillColor={
                              this.state.selectedFile?.fileNo === index
                                ? "#E52222"
                                : "#5d5d5d"
                            }
                            height={
                              this.state.selectedFile?.fileNo === index
                                ? "25px"
                                : "25px"
                            }
                            width={
                              this.state.selectedFile?.fileNo === index
                                ? "25px"
                                : "25px"
                            }
                          />

                          <Label
                            text={file.pdfName}
                            fontSize="10px"
                            color="#373D4B"
                          ></Label>
                        </div>
                      );
                    })}
                  </Carousel>
                </div>
              </section>
            </div>
          </Grid>
          <Grid item xs={3} className="angle-arrow-grid">
            <div>
              <div
                className="angle-arrow-display"
              >
                <IconButton
                className={this.state.selectedFile?.pageNo + 1 <= 1
                  ? "arrow-angle-condition"
                  : ""}
                  // disabled={true}
                  onClick={(e) =>
                    this.state.selectedFile?.pageNo !== 0 &&
                    this?.handlePageChange("prev")
                  }
                >
                  <img
                    className="angle-arrow-left"
                    src={AngleArrowLeft}
                    alt="prev page"
                  />
                </IconButton>

                <IconButton
                  className={this.state.selectedFile?.pageNo + 1 >=
                    this.props?.coorData[this.state.selectedFile?.fileNo]?.pages
                      ?.length ? "arrow-angle-condition":""}
                  onClick={(e) =>
                    this.state.selectedFile?.pageNo + 1 !==
                      this.props?.coorData[this.state.selectedFile?.fileNo]
                        ?.pages?.length && this?.handlePageChange("next")
                  }
                >
                  <img
                    className="angle-arrow-right"
                    src={AngleArrowRight}
                    alt="next page"
                  />
                </IconButton>
              </div>

              <>
                <h1 className="angle-arrow-text">{`Page ${
                  Number(this.state.selectedFile?.pageNo) + 1
                }/ ${
                  this.props?.coorData[this.state.selectedFile?.fileNo]?.pages
                    ?.length
                }`}</h1>
              </>
            </div>

            <MapToolBar
              file={this.props?.coorData[this.state.selectedFile?.fileNo]}
              handlePageChange={this.handlePageChange}
              selectedFile={this.state.selectedFile}
              searchPageClick={this.searchPageClick}
              onClickZoom={this.onClickZoom}
              zoom={this.state.zoom}
              rotateClick={this.rotateClick}
              fitToScreenClick={this.fitToScreenClick}
              onClickChangeOrientation={this.onClickChangeOrientation}
            />
          </Grid>
        </Grid>
        <Grid className="view_pdf_new" md={12} id="viewPdfId">
          <div
            id="container"
            style={{
              transform: `rotate(${this.state.pageRotateAngle}deg)`,
              transition: "transform 150ms ease", // smooth transition
              cursor: "grab",
              left: [
                90, 270, 450, 630, 810, 990, 1170, 1350, 1530, 1710, 1890,
              ].includes(this.state.pageRotateAngle)
                ? "14%"
                : 0,
              position: "relative",
            }}
          >
            <PrismaZoom
              maxZoom={10}
              animDuration={0.5}
              allowZoom={this.state.allowZoom}
              ref={this.state.prismaZoom}
              onZoomChange={this.onZoomChange}
            >
              {this.state?.imageLoaded ? (
                <ImageMapper
                  src={this.state?.data?.imageUrl}
                  map={this.state?.data}
                  // width={600}
                  // height={768}
                  width={this?.state?.imageMapperWidth}
                  height={this?.state?.imageMapperHeight}
                  onClick={(area, index, e) => this.clicked(area, index, e)}

                  imgWidth={this?.state?.imageMapperWidth}
                  natural={true}
                  responsive={true}
                  parentWidth={this?.state?.imageMapperWidth}
                />
              ) : (
                <Box
                  className="imageView-progressbar-div"
                >
                  <CircularProgress />
                  <span
                    className="circular-loader-style"
                  >
                    Loading..
                  </span>
                </Box>
              )}
            </PrismaZoom>
          </div>
        </Grid>
      </Box>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    acts: bindActionCreators(acts, dispatch),
  };
};

function mapStateToProps(state) {
  return {
    coorData: state.pro?.coorData?.coordinatesDetails || [],
    apiStatus: state.pro?.apiStatus,
    pdfAndPageDetails: state.pro?.pdfAndPageDetails,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageViewer);
